import { createFeatureSelector, createSelector } from '@ngrx/store';
import { skuSearchFeatureKey, SkuSearchState } from './sku-search.reducer';

export const selectSkuSearchState = createFeatureSelector<SkuSearchState>(skuSearchFeatureKey);

export const selectSkuSearchResults = createSelector(selectSkuSearchState, (state: SkuSearchState) => state.skuResults);

export const selectSkuCount = createSelector(selectSkuSearchState, (state: SkuSearchState) => state.skuCount);

export const selectSkuSearch = createSelector(selectSkuSearchState, (state: SkuSearchState) => state);
